// Mock data for Arena Garden — Food & Beverage
// Same branding / structure as the Tauron Arena (venue-dining-1) project,
// but ONLY the Food Trucks zone outlets are included (no Kiosks, no VIP Restaurants).

export const ASSETS = {
  foraLogo:
    "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/ahuwpdsq_image.png",
  arenaLogo:
    "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/je84hl8j_image.png",
  foodTrucksHero:
    "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/j5lvo4ox_image.png",
  favicon: "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/ahuwpdsq_image.png",
};

// The 8 Food Trucks outlets (identical to Tauron Arena Food Trucks zone)
export const OUTLETS = [
  {
    id: "61469617-7ac9-4878-a142-1000b5bbacb6",
    name: "BURGER",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/7NFG1XBP",
    description_en: "Burgers & fries",
    description_pl: "Burgery i frytki",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/j5lvo4ox_image.png",
    sort_order: 1,
  },
  {
    id: "b0658df9-3794-45cf-8207-007b4fccc112",
    name: "FRYTKA",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/P350GFQZ",
    description_en: "Fries & loaded fries",
    description_pl: "Frytki i frytki belgijskie",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/7lu30tt0_image.png",
    sort_order: 2,
  },
  {
    id: "ca26b1a7-a2b1-4988-85f7-95fa0c912498",
    name: "SŁODZIAK",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/LOMJABKM",
    description_en: "Sweet treats & desserts",
    description_pl: "Słodkości i desery",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/w6z7objg_image.png",
    sort_order: 3,
  },
  {
    id: "048b17ca-e077-4ad3-9817-04ceda965f2d",
    name: "ZAPIEKANKA",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/UYHV0HV5",
    description_en: "Polish baguette pizzas",
    description_pl: "Zapiekanki",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/j5lvo4ox_image.png",
    sort_order: 4,
  },
  {
    id: "7a1fde01-c8c3-40cf-adf7-d1fe9595365a",
    name: "HOT-DOG",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/GT02LOS6",
    description_en: "Hot dogs",
    description_pl: "Hot dogi",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/7lu30tt0_image.png",
    sort_order: 5,
  },
  {
    id: "4d59d9e2-6cd0-45b8-b8d4-b90c403f2d03",
    name: "Bar & Street Food",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/GUZOALYS",
    description_en: "Street food & drinks",
    description_pl: "Street food i napoje",
    image_url: "/images/bar-street-food.jpg",
    sort_order: 6,
  },
  {
    id: "93de4ee6-3b45-43ef-ad85-abb6805b998d",
    name: "PIAGGIO",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/D5SXLVOG",
    description_en: "Snacks & drinks",
    description_pl: "Przekąski i napoje",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/j5lvo4ox_image.png",
    sort_order: 7,
  },
  {
    id: "fe814904-fc7e-45a9-9c75-dee90ec43477",
    name: "LODY",
    zone: "food_truck",
    menu_url: "https://qr.master-fb.com/IBZMTLV3",
    description_en: "Ice cream",
    description_pl: "Lody",
    image_url:
      "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/7lu30tt0_image.png",
    sort_order: 8,
  },
];

// Internationalization strings (EN / PL) — mirrors the original project
export const I18N = {
  en: {
    label: "FOOD & BEVERAGE",
    venue_title: "Arena Garden",
    meta: (n) => `${n} outlets · 1 zone`,
    zone_name: "Food Trucks",
    zone_desc: "Street food & quick bites",
    zone_count: (n) => `${n} outlets`,
    view_menu: "View Menu",
    powered_by: "Powered by",
  },
  pl: {
    label: "GASTRONOMIA",
    venue_title: "Arena Garden",
    meta: (n) => `${n} punktów · 1 strefa`,
    zone_name: "Food Trucki",
    zone_desc: "Street food i szybkie przekąski",
    zone_count: (n) => `${n} punktów`,
    view_menu: "Zobacz menu",
    powered_by: "Obsługiwane przez",
  },
};
